export const listAsConjunction = (list: string[], languageCode: string = 'nl') => new Intl.ListFormat(languageCode, {
    style: 'long',
    type: 'conjunction'
}).format(list)

export const listAsDisjunction = (list: string[], languageCode: string = 'nl') => new Intl.ListFormat(languageCode, {
    style: 'long',
    type: 'disjunction'
}).format(list)
